export default __webpack_public_path__ + "static/media/Prospects.3fe80863.svg";